import { render, staticRenderFns } from "./registre-biochimie.html?vue&type=template&id=2730a5eb&scoped=true&external"
import script from "./registre-biochimie.js?vue&type=script&lang=js&external"
export * from "./registre-biochimie.js?vue&type=script&lang=js&external"
import style0 from "./registre-biochimie.scss?vue&type=style&index=0&id=2730a5eb&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2730a5eb",
  null
  
)

export default component.exports